import { NavLink, RouteObject } from "react-router";

import {
  Badge,
  BadgeColor,
  checkTabIsActive,
  DescriptionList,
  PageHeading,
  Spinner,
  Tabs,
} from "@prequel/shared-components";

import { useOrg } from "@/api/queries/orgs";
import { useUsers } from "@/api/queries/users";

const tabs = [
  <NavLink key="org" to="/settings" className={checkTabIsActive}>
    Organization
  </NavLink>,
];

const SettingsPage = () => {
  const { data: org, isLoading: isLoadingOrg } = useOrg();
  const { data: users, isLoading: isLoadingUsers } = useUsers();

  if (isLoadingOrg || isLoadingUsers) {
    return <Spinner />;
  }

  if (!org || !users) {
    return <Spinner />;
  }

  return (
    <div className="max-w-6xl px-7 py-4 pb-16">
      <PageHeading title="Settings" />
      <Tabs tabs={tabs} />
      <div className="mt-2 divide-y divide-gray-200">
        <DescriptionList>
          <DescriptionList.Item label="Name" value={org?.name} />
          <DescriptionList.Item label="ID" value={org?.id} />
          <DescriptionList.Item
            label="Users"
            value={users?.map((p) => (
              <Badge key={p.email} className="mr-1" text={p.email} color={BadgeColor.GRAY} />
            ))}
          />
          <DescriptionList.Item label="Default sync frequency (minutes)" value={org.default_frequency_minutes} />
          <DescriptionList.Item
            label="Fastest allowed sync frequency (minutes)"
            value={org.fastest_allowed_frequency_minutes}
          />
          <DescriptionList.Item label="Tenancy" value={org.sources_schema_tenanted ? "Schema-based" : "Column-based"} />
          <DescriptionList.Item label="Single Sign-On (SSO)" value={org.sso_enabled ? "Enabled" : "Disabled"} />
          {org?.aws_iam_role_id !== undefined && (
            <DescriptionList.Item label="AWS IAM Role ID" value={org.aws_iam_role_id} />
          )}
          {org?.aws_iam_role_name !== undefined && (
            <DescriptionList.Item label="AWS IAM Role Name" value={org.aws_iam_role_name} />
          )}
          {org?.gcp_iam_role_id !== undefined && (
            <DescriptionList.Item label="GCP IAM Role ID" value={org.gcp_iam_role_id} />
          )}
          {org?.gcp_iam_role_name !== undefined && (
            <DescriptionList.Item label="GCP IAM Role Name" value={org.gcp_iam_role_name} />
          )}
        </DescriptionList>
      </div>
    </div>
  );
};

export const settingsRoutes: RouteObject = {
  path: "settings",
  handle: {
    breadcrumb: () => ({ label: "Settings" }),
  },
  element: <SettingsPage />,
};

export default SettingsPage;
